import * as React from 'react';
import styled from 'styled-components';
import {useFormikContext} from 'formik';
import Row from 'components/Row';
import Column from 'components/Column';
import Radio from 'components/Radio';
import FormContainer from '../../containers/FormContainer';
import {WebinarObject, ContentType} from 'api/webinar/types';

const Container = styled.div`
  gap: 20px;
  align-items: center;
  grid-auto-flow: column;
  display: inline-grid;
`;

/**
 * The content type form part
 * @return {React.ReactElement}
 * @constructor
 */
export default function ContentTypeForm(): React.ReactElement {
  const formContext = useFormikContext<Partial<WebinarObject>>();

  /**
   * Render content
   * @return {JSX.Element}
   */
  function renderContent(): JSX.Element {
    /**
     * Handle date change
     * @param {React.ChangeEvent<HTMLInputElement>} event
     */
    function handleChange(event: React.ChangeEvent<HTMLInputElement>): void {
      formContext.setFieldValue('content.contentType', event.target.value);
      formContext.submitForm();
    }

    return (
      <React.Fragment>
        <Row>
          <Column>
            <Row>
              <Column>
                <Container>
                  <Radio
                    name="contentType"
                    label="Grow Place"
                    value={ContentType.Local}
                    onChange={handleChange}
                  />
                  <Radio
                    name="contentType"
                    label="ZOOM"
                    value={ContentType.Zoom}
                    onChange={handleChange}
                  />
                  <Radio
                    name="contentType"
                    label="Youtube"
                    value={ContentType.Youtube}
                    onChange={handleChange}
                  />
                </Container>
              </Column>
            </Row>
          </Column>
        </Row>
      </React.Fragment>
    );
  }

  return (
    <FormContainer title="Источник трансляции">
      {renderContent()}
    </FormContainer>
  );
}
